import Vue from 'vue';
import {
  tooltip,
  message, Switch, FormModel, input, icon, select, layout, menu, tree, pagination, button, radio, DatePicker, avatar, Dropdown, modal, row, col, statistic, tag, Progress, Cascader, TreeSelect, Badge, Tabs, InputNumber,
  spin, localeProvider, ConfigProvider, empty, Popover, Card, Table, Upload, Checkbox, Form, Popconfirm, Steps, Alert, Collapse, Divider, breadcrumb, AutoComplete, Carousel,notification
} from 'ant-design-vue';
Vue.use(tooltip)
Vue.use(FormModel);
Vue.use(Popover);
Vue.use(Divider)
Vue.use(input);
Vue.use(icon);
Vue.use(select);
Vue.use(layout);
Vue.use(menu);
Vue.use(tree)
Vue.use(pagination)
Vue.use(button)
Vue.use(radio)
Vue.use(DatePicker)
Vue.use(avatar)
Vue.use(Dropdown)
Vue.use(row)
Vue.use(col)
Vue.use(statistic)
Vue.use(tag)
Vue.use(Progress)
Vue.use(Carousel)
Vue.use(Cascader)
Vue.use(TreeSelect)
Vue.use(Badge)
Vue.use(Collapse)
Vue.use(Tabs)
Vue.use(InputNumber)
Vue.use(spin)
Vue.use(Switch)
Vue.use(modal)
Vue.use(empty)
Vue.use(localeProvider)
Vue.use(ConfigProvider)
Vue.use(Card)
Vue.use(Table)
Vue.use(Upload)
Vue.use(Checkbox)
Vue.use(Form)
Vue.use(Popconfirm)
Vue.use(breadcrumb)
Vue.use(Steps)
Vue.use(Alert)
Vue.use(AutoComplete)
Vue.prototype.$modal = modal
Vue.prototype.$message = message;
Vue.prototype.$notification = notification;